import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
// import { useWidget } from '@bitcoin-portal/mpc-widget';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainWrapper,
  FirstRowWrapper,
  BlueSection,
  ContentWrapper,
  TextWrapper,
  Title,
  Text,
  ButtonWrapper,
  SignUpButton,
  GetAppButton,
  BitcoinSection,
  BitcoinImage,
  SecondRowWrapper,
  DesktopImageSection1,
  DesktopImage1,
  DesktopImageSection2,
  AppTitle,
  DesktopImage2,
} from './styled';

const ReadytoGetStarted = () => {
  const { formatMessage } = useIntl();
  // const { hasAccount, startLogin } = useWidget();

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainWrapper>
            <FirstRowWrapper>
              <BlueSection>
                <ContentWrapper>
                  <TextWrapper>
                    <Title>
                      <FormattedMessage id="home.readytogetstarted.title" />
                    </Title>
                    <Text>
                      <FormattedMessage id="home.readytogetstarted.text" />
                    </Text>
                  </TextWrapper>
                  <ButtonWrapper>
                    {/* {!hasAccount ? (
                      <SignUpButton
                        onClick={startLogin}
                        onMouseEnter={handleRipple}
                      >
                        <FormattedMessage id="home.readytogetstarted.buttonText1" />
                      </SignUpButton>
                    ) : (
                      <SignUpButton
                        href={formatMessage({ id: 'home.readytogetstarted.viewDashboardLink' })}
                        target="_blank"
                        onMouseEnter={handleRipple}
                      >
                        <FormattedMessage id="home.readytogetstarted.viewDashboardButton" />
                      </SignUpButton>
                    )} */}
                    <SignUpButton
                      href={formatMessage({
                        id: 'home.readytogetstarted.viewDashboardLink',
                      })}
                      target="_blank"
                      onMouseEnter={handleRipple}
                    >
                      <FormattedMessage id="home.readytogetstarted.buttonText1" />
                    </SignUpButton>
                    <GetAppButton
                      href={formatMessage({
                        id: 'home.readytogetstarted.buttonLink2',
                      })}
                      target="_blank"
                      onMouseEnter={handleRipple}
                    >
                      <FormattedMessage id="home.readytogetstarted.buttonText2" />
                    </GetAppButton>
                  </ButtonWrapper>
                </ContentWrapper>
              </BlueSection>
              <BitcoinSection>
                <BitcoinImage
                  src={formatMessage({
                    id: 'home.readytogetstarted.image1.src',
                  })}
                  alt={formatMessage({
                    id: 'home.readytogetstarted.image1.alt',
                  })}
                />
              </BitcoinSection>
            </FirstRowWrapper>
            <SecondRowWrapper>
              <DesktopImageSection1>
                <DesktopImage1
                  src={formatMessage({
                    id: 'home.readytogetstarted.image2.src',
                  })}
                  alt={formatMessage({
                    id: 'home.readytogetstarted.image2.alt',
                  })}
                />
              </DesktopImageSection1>
              <DesktopImageSection2>
                <AppTitle>
                  <FormattedMessage id="home.readytogetstarted.appTitle" />
                </AppTitle>
                <DesktopImage2
                  src={formatMessage({
                    id: 'home.readytogetstarted.image3.src',
                  })}
                  alt={formatMessage({
                    id: 'home.readytogetstarted.image3.alt',
                  })}
                />
              </DesktopImageSection2>
            </SecondRowWrapper>
          </MainWrapper>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment ReadytoGetStarted on Json {
    readytogetstarted {
      title
      text
      buttonText1
      viewDashboardButton
      viewDashboardLink
      buttonText2
      buttonLink2
      appTitle
      image1 {
        src
        alt
      }
      image2 {
        src
        alt
      }
      image3 {
        src
        alt
      }
      mobileImage1 {
        src
        alt
      }
      mobileImage2 {
        src
        alt
      }
    }
  }
`;

export default ReadytoGetStarted;
